import PlainNav, { NavItem } from 'app/common/ui/PlainNav'
import { DotsLoader } from 'app/common/components/Loader'
import SimpleDate from 'app/common/classes/simple-date'

import selectCategories from './selectCategories'
import MenuCategoriesApi from '../../MenuCategoriesApi'
import { categoryVerification } from './categoryVerification'

type Props = {
  className?: string
  personId?: number
  dishesExist: boolean
  complexesExist: boolean
  loading: boolean
  // наличие блюд в категории
  dishesByCategory: { [catId: string]: unknown }
  // количество блюд и комплектов из категории catId, присутствующих в заказе
  countByCategoryId: { [catId: string]: number }
  schoolId?: number
  categoryId?: string
  onChangeCategory: (categoryId: string) => void
  createUrl: (params: { date?: SimpleDate; categoryId?: string }) => string
}

const CategoriesNav = ({
  personId,
  className,
  dishesExist,
  complexesExist,
  loading,
  dishesByCategory,
  countByCategoryId,
  schoolId,
  categoryId,
  onChangeCategory,
  createUrl,
}: Props) => {
  if (loading) {
    return <DotsLoader />
  }

  return (
    <MenuCategoriesApi personId={personId} schoolId={schoolId}>
      {({ content, loading: categoriesLoading }) => {
        const categories = selectCategories(content, dishesByCategory)

        categoryVerification({
          hasDishes: dishesExist,
          hasComplexes: complexesExist,
          currentCategoryId: categoryId,
          dishesByCategory,
          onChangeCategory,
        })

        return (
          <>
            <PlainNav className={className} loading={categoriesLoading}>
              {categories.map(({ id, title }) => (
                <NavItem key={id} to={createUrl({ categoryId: String(id) })}>
                  {`${title}`}
                  {countByCategoryId[id] ? `\u00A0(${countByCategoryId[id]})` : ''}
                </NavItem>
              ))}
              {complexesExist && (
                <NavItem to={createUrl({ categoryId: 'kits' })}>
                  {'Комплекты'}
                  {countByCategoryId.complexes ? `\u00A0(${countByCategoryId.complexes})` : ''}
                </NavItem>
              )}
            </PlainNav>
          </>
        )
      }}
    </MenuCategoriesApi>
  )
}

export default CategoriesNav
